// extracted by mini-css-extract-plugin
export default {"cr_map__wrapper":"CountryReportMap_cr_map__wrapper__2+nVJ"};